import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useSocket } from "../hooks/useSocket";
import FileSelector from "./FileSelector";
import LogViewer from "./LogViewer";

export default function Dashboard() {
  const { token, logout } = useAuth();
  const { logs, status, error, subscribe, clearLogs } = useSocket(token);
  const [selectedFile, setSelectedFile]     = useState(null);
  const [autoScroll, setAutoScroll]         = useState(true);

  function handleFileSelect(filePath) {
    setSelectedFile(filePath);
    subscribe(filePath);
  }

  const statusLabel = {
    connected:    "Live",
    connecting:   "Connecting…",
    disconnected: "Disconnected",
    error:        "Error",
  }[status] || status;

  return (
    <div className="dashboard">
      {/* ── Top Bar ── */}
      <header className="topbar">
        <div className="topbar-left">
          <span className={`status-dot ${status}`} title={`Socket: ${statusLabel}`} />
          <h2>🖥️ PM2 Log Viewer</h2>
          {selectedFile && (
            <span style={{ fontSize: "0.78rem", color: "#8b949e" }}>
              — {selectedFile.split("/").pop()}
            </span>
          )}
        </div>
        <div className="topbar-right">
          <button
            className="btn-icon"
            onClick={() => setAutoScroll((a) => !a)}
            title="Toggle auto-scroll"
          >
            {autoScroll ? "⏬ Auto-scroll ON" : "⏸ Auto-scroll OFF"}
          </button>
          <button
            className="btn-icon"
            onClick={clearLogs}
            title="Clear current logs from view"
          >
            🗑 Clear
          </button>
          <button className="btn-logout" onClick={logout}>Sign Out</button>
        </div>
      </header>

      {/* ── File Selector ── */}
      <FileSelector onSelect={handleFileSelect} selectedFile={selectedFile} />

      {/* ── Log Stream ── */}
      <LogViewer
        logs={logs}
        loading={status === "connecting"}
        error={error}
        autoScroll={autoScroll}
      />

      {/* ── Status Bar ── */}
      <footer className="statusbar">
        <span>Socket: <strong style={{ color: status === "connected" ? "#3fb950" : "#f85149" }}>{statusLabel}</strong></span>
        <span>{logs.length.toLocaleString()} lines buffered</span>
        <span>{selectedFile ? `Watching: ${selectedFile}` : "No file selected"}</span>
      </footer>
    </div>
  );
}
